// src/components/billing/BillingActivationBanner.js
import React from "react";
import { Alert, Box, Stack, Typography } from "@mui/material";
import ButtonComponent from "../ui/ButtonComponent";

export default function BillingActivationBanner({
  dismissUntil,
  onActivate,
  onDismiss,
  dismissing,
}) {
  const untilText = dismissUntil
    ? dismissUntil.toLocaleDateString(undefined, {
        year: "numeric",
        month: "short",
        day: "numeric",
      })
    : null;

  return (
    <Box
      sx={{
        position: "fixed",
        top: 0,
        left: 0,
        right: 0,
        zIndex: 1500,
        px: 2,
        pt: "calc(env(safe-area-inset-top, 0px) + 12px)",
        pointerEvents: "none", // allow clicks only inside the alert
      }}
    >
      <Box
        sx={{
          width: "100%",
          maxWidth: 1100,
          mx: "auto",
          pointerEvents: "auto",
        }}
      >
        <Alert
          severity="info"
          sx={{
            borderRadius: 2,
            boxShadow: 3,
            bgcolor: "background.paper",
            alignItems: "center",
            border: "1px solid",
            borderColor: "divider",
          }}
        >
          <Stack
            direction={{ xs: "column", sm: "row" }}
            spacing={1.5}
            alignItems={{ xs: "flex-start", sm: "center" }}
            justifyContent="space-between"
            sx={{ width: "100%" }}
          >
            <Box>
              <Typography variant="body2" sx={{ fontWeight: 700 }}>
                Subscription activation required
              </Typography>
              <Typography variant="caption" color="text.secondary">
                Activate your Kinova subscription to unlock all features.
                {untilText ? ` Reminder hidden until ${untilText}.` : ""}
              </Typography>
            </Box>

            <Stack direction="row" spacing={1} sx={{ pt: { xs: 0.5, sm: 0 } }}>
              <ButtonComponent label="Activate" onClick={onActivate} />
              <ButtonComponent
                label="Dismiss"
                type="secondary"
                onClick={onDismiss}
                disabled={!!dismissing}
                isLoading={!!dismissing}
              />
            </Stack>
          </Stack>
        </Alert>
      </Box>
    </Box>
  );
}